export const tonBalancePaths = [
  "/store/ton",
  "/wallet/withdrawal",
  "/wallet/deposit",
  "/sale-chest"
]
